export interface DirectoryRole {
  id: string;
  name: string;
  description: string;
  hasWebAccess: boolean;
}

export const DIRECTORY_ROLE_NAME = {
  ADMIN: 'admin',
  CHOFER: 'chofer',
  VISOR: 'visor',
} as const;

export type DirectoryRoleName = (typeof DIRECTORY_ROLE_NAME)[keyof typeof DIRECTORY_ROLE_NAME];

export const DIRECTORY_ROLE_LABEL: Record<DirectoryRoleName, string> = {
  [DIRECTORY_ROLE_NAME.ADMIN]: 'Administrador',
  [DIRECTORY_ROLE_NAME.CHOFER]: 'Chofer',
  [DIRECTORY_ROLE_NAME.VISOR]: 'Visor',
};

export const DIRECTORY_ROLE_HELP: Partial<Record<DirectoryRoleName, string>> = {
  [DIRECTORY_ROLE_NAME.CHOFER]:
    'Usa Kore Driver para registrar entregas y no entregas. No entra al dashboard web.',
};

export function resolveDirectoryRoleLabel(role: DirectoryRole): string {
  const knownLabel = DIRECTORY_ROLE_LABEL[role.name as DirectoryRoleName];
  if (knownLabel) return knownLabel;
  if (role.description) return role.description;
  return role.name;
}

export function resolveDirectoryRoleHelp(role: DirectoryRole): string {
  const knownHelp = DIRECTORY_ROLE_HELP[role.name as DirectoryRoleName];
  if (knownHelp) return knownHelp;
  if (role.description) return role.description;
  return '';
}

export function findDirectoryRoleByName(
  roles: DirectoryRole[],
  roleName: string | null,
): DirectoryRole | null {
  if (!roleName) return null;
  const normalized = roleName.trim().toLowerCase();
  return roles.find((role) => role.name.trim().toLowerCase() === normalized) ?? null;
}
